import React from "react";
import useTVL from "@hooks/useTVL";
import { useRestakeApy } from "@hooks/useRestakeApy";
import AvsRibbonItem from "./AvsRibbonItem";
import { numberToCurrency } from "utils";

export default function AvsRibbonGrid() {
  const tvl = useTVL();
  const apyData = useRestakeApy();
  return (
    <>
      <AvsRibbonItem
        label="APY"
        value={apyData.data ? `${apyData.data.totalAPY.toFixed(1)}%` : "-"}
      />
      <AvsRibbonItem
        label="TVL"
        value={
          tvl.tvl?.value ? numberToCurrency(`${tvl.tvl.value}`) + " ETH" : "-"
        }
      />
    </>
  );
}
